/**
 * Approval Reducer for Story 2: Dynamic Approval Workflow
 */

const initialState = {
  pendingApprovals: [],
  currentReview: null,
  approvalHistory: [],
  loading: false,
  error: null,
  userRole: null,
  canApprove: null, // null = belum diketahui, true = bisa approve, false = tidak bisa
};

const approvalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_INFO": {
      return {
        ...state,
        userRole: action.payload.role || null,
        canApprove: action.payload.can_approve ?? null,
        loading: false,
      };
    }

    case "SET_PENDING_APPROVALS": {
      return {
        ...state,
        pendingApprovals: action.payload.data || [],
        userRole: action.payload.user_role || state.userRole,
        loading: false,
        error: null,
      };
    }

    case "SET_APPROVAL_LOADING": {
      return {
        ...state,
        loading: action.payload,
      };
    }

    case "SET_APPROVAL_ERROR": {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }

    case "SET_CURRENT_REVIEW": {
      return {
        ...state,
        currentReview: action.payload,
        loading: false,
      };
    }

    case "APPROVE_BOOKING_SUCCESS": {
      return {
        ...state,
        pendingApprovals: state.pendingApprovals.filter(
          (approval) => approval.id !== action.payload.approval_id
        ),
        currentReview: null,
        loading: false,
      };
    }

    case "REJECT_BOOKING_SUCCESS": {
      return {
        ...state,
        pendingApprovals: state.pendingApprovals.filter(
          (approval) => approval.id !== action.payload.approval_id
        ),
        currentReview: null,
        loading: false,
      };
    }

    case "SET_APPROVAL_HISTORY": {
      return {
        ...state,
        approvalHistory: action.payload,
        loading: false,
      };
    }

    case "CLEAR_CURRENT_REVIEW": {
      return {
        ...state,
        currentReview: null,
      };
    }

    default:
      return state;
  }
};

export default approvalReducer;
